import { ReactComponent as IconNoMessage } from '@/assets/svgs/no-message.svg';
import { ReactComponent as IconFolder } from "@/assets/svgs/package-folder-icon.svg";
import { ReactComponent as IconPaperClip } from "@/assets/svgs/paper-clip-small.svg";
import { ReactComponent as IconPinToTop } from "@/assets/svgs/pin-solid-small.svg";
import MultiLevelDropDown from "@/components/MultiLevelMenuDropDown/index.js";
import { ToastContext } from "@/context/toast/index";
import useModal from '@/hooks/use-modal/index';
import packageApi from "@/services/api/packages.js";
import getDateTime from "@/utils/get-date-time.js";
import moment from 'moment';
import { useContext, useState } from 'react';
import MultiClamp from 'react-multi-clamp';
import { useNavigate, useLocation } from '@/lib/router-dom';
import DeletePackageFolderModal from './delete-package-folder-modal.jsx';
import RenamePackageFolderModal from './rename-package-folder-modal.jsx';
import DownloadAllDataModal from "./download-all-data-modal.jsx";

export default function PackageFolderDataTable({
	items,
	setSortConfig,
	sortConfig,
	refreshData,
	setRefreshData
}) {
	const packageActivity = "folder";
	const { goTo } = useNavigate();
	const { addToastMessage } = useContext(ToastContext);

	const { visible: isShowRenameFolderModal, show: showRenameFolderModal, hide: hideRenameFolderModel } = useModal()
	const { visible: isShowDeleteFolderModal, show: showDeleteFolderModal, hide: hideDeleteFolderModal } = useModal()
	const { visible: isDownloadAllModalVisible, hide: hideDownloadAllModal, show: showDownloadAllModal } = useModal();

	const [selectedRenameItem, setSelectedRenameItem] = useState('');
	const [selectedDeleteItem, setSelectedDeleteItem] = useState('');
	const [selectedFolderItem, setSelectedFolderItem] = useState();

	function getSortClassName(name) {
		if (!sortConfig) {
			return
		}

		if (sortConfig.key === name) {
			return sortConfig.direction === true ? "is-asc" : "is-desc"
		}

		return ""
	}

	function handleSortConfig(key) {
		let direction = sortConfig.direction
		if (sortConfig.key === key) {
			direction = !direction
		} else {
			direction = true
		}

		setSortConfig({ key, direction })
	}

	const handlePin = async (item) => {
		const [error] = await packageApi.pinPackage(item.pinned ? "unpin" : "pin", {
			eclipFolderId: item.id
		});

		if (error) {
			return addToastMessage(item.pinned ? "Pin not removed" : "Pin not added", 'error')
		}

		setRefreshData(!refreshData)

		addToastMessage(
			item.pinned ? "Removed pin successfully" : "Pinned successfully",
			"success"
		);
	};

	const list = items?.map((item) => {
		return (
			<>
				<div className="data-table__table__body__row">
					<div className="package-folder-table__contents-col"
						key={item.id}
						onClick={() => goTo(`/package/folder/${item.id}`,{isVeridaptFolder: item.isVeridapt})}
						data-testid="folder-item"
					>
						<div className="package-folder-data-table package-folder-table__data-col--pin">
							{item.pinned && <IconPinToTop />}
						</div>

						<div className="package-folder-data-table package-folder-table__data-col--folder-title">
							<div className="package-folder-table__folder-title">
								<div>
									<div className="package-folder-card__icon--non-veridapt"><IconFolder /></div>
								</div>
								<div className='tooltip'>
									<MultiClamp clamp={1}>{item.name}</MultiClamp>
									<span className={"tooltiptext__package-folder-name"}>
										{item.name}
									</span>
								</div>
							</div>
						</div>

						<div className="package-folder-data-table package-folder-table__data-col--package-count">
							<div className="package-folder-table__pacakge-count">
								<IconPaperClip />
								{String(item.eclipCount).padStart(2, '0')}
							</div>
						</div>

						<div className="package-folder-data-table package-folder-table__data-col--create-date">
							<div className="package-folder-table__created-date-text">{moment(item.created).format('DD/MM/YY')}</div>
						</div>

						<div className="package-folder-data-table flex-item package-folder-table__data-col--modified-date">
							<div className="package__modified-date package-folder-table__modified-date-text">
								{getDateTime(item.modified)}
							</div>
						</div>
					</div>
					<div className="package-folder-table__menu-col">
						<div className="package-folder-data-table package-data-table__menu" data-testid="side-menu">
							<MultiLevelDropDown
								menuList={[
									{
										label: "Download",
										onClick: (e) => {
											e.stopPropagation();
											setSelectedFolderItem(item);
											showDownloadAllModal();
										},
									},
									item.isVeridapt ? undefined :
									{
										label: 'Rename',
										onClick: (e) => {
											e.stopPropagation();
											setSelectedRenameItem(item);
											showRenameFolderModal()
										},
									},
									{
										label: item.pinned ? "Unpin" : "Pin",
										onClick: (e) => {
											e.stopPropagation();
											handlePin(item);
										},
									},
									item.isVeridapt ? undefined :
									{
										label: 'Delete',
										labelColor: "#A72E12",
										onClick: (e) => {
											e.stopPropagation();
											setSelectedDeleteItem(item);
											showDeleteFolderModal()
										},
									},
								]}
							/>
						</div>
					</div>

				</div>
			</>
		)
	})

	return (
		<>
			<div className="data-table__content">
				<div className="data-table__content__cols">
					<div className="data-table__content__col">
						<div className="data-table__table">
							<div className="data-table__table__head">
								<div className="data-table__table__head__row package-folder-table__header-text">
									<div className="package-folder-table__contents-col">
										<div className={'package-folder-data-table package-folder-table__data-col--pin'}></div>
										<div
											className={`package-folder-data-table data-table__table__head__title__sort-order ${getSortClassName("name")} package-folder-table__data-col--folder-title`}
											id="dataElementId" onClick={
												(e) => {
													handleSortConfig('name')
												}
											}>
											Folder Name <span className="data-table__table__head__icon__sort-order"></span>
										</div>
										<div
											className={`package-folder-data-table data-table__table__head__title__sort-order ${getSortClassName("eclipCount")} package-folder-table__data-col--package-count`}
											id="orgId" onClick={
												(e) => {
													handleSortConfig('eclipCount')
												}
											}>
											No.of Packages <span className="data-table__table__head__icon__sort-order"></span>

										</div>

										<div
											className={`package-folder-data-table data-table__table__head__title__sort-order ${getSortClassName("created")} package-folder-table__data-col--create-date`}
											id="created" onClick={
												(e) => {
													handleSortConfig('created')
												}
											}>
											Created on <span className="data-table__table__head__icon__sort-order"></span>
										</div>
										<div
											data-testid='sort-order'
											className={`package-folder-data-table data-table__table__head__title__sort-order ${getSortClassName("modified")} package-folder-table__data-col--modified-date`}
											id="modified" onClick={
												(e) => {
													handleSortConfig('modified')
												}
											}>
											<div className="package__modified-date flex-item">
												Last modified <span className="data-table__table__head__icon__sort-order"></span>
											</div>

										</div>
									</div>
									<div className="package-folder-table__menu-col">
										<div className="package-folder-data-table">
											<div className='package-data-table__header-menu'></div>
										</div>
									</div>
								</div>
							</div>
							<div className="data-table__table__body">
								{list?.length > 0 ?
									list :
									<div className="data-table__empty">
										<div className="data-table__empty__icon">
											<IconNoMessage />
										</div>
									</div>
								}
							</div>
						</div>
					</div>
				</div>
			</div>

			<RenamePackageFolderModal
				visible={isShowRenameFolderModal}
				close={hideRenameFolderModel}
				data={selectedRenameItem}
			/>

			<DeletePackageFolderModal
				visible={isShowDeleteFolderModal}
				close={hideDeleteFolderModal}
				id={selectedDeleteItem?.id}
			/>

			<DownloadAllDataModal
				visible={isDownloadAllModalVisible}
				close={hideDownloadAllModal}
				all={true}
				isFolder={true}
				downloadName={selectedFolderItem?.name}
				packageActivity={packageActivity}
				downloadId={[selectedFolderItem?.id]}
				isVeridapt={selectedFolderItem?.isVeridapt}
			/>
		</>


	)

}
